import React from 'react'
import './BulletPoints.scss'

interface BulletPointsProps {
  className?: string
  bulletPointOne?: string
  bulletPointTwo?: string
  bulletPointThree?: string
  checkmarkColor?: string
}

const BulletPoints = ({
  className,
  bulletPointOne,
  bulletPointTwo,
  bulletPointThree,
  checkmarkColor,
}: BulletPointsProps) => {
  return (
    <ul className={`bullet-points ${className ? className : ''}`} data-testid='bullet-points'>
      {typeof bulletPointOne !== 'undefined' && (
        <li className='bullet-point'>
          <div className='grid grid-flex gutter-s palm-font-xs' data-testid='bullet-point'>
            <div className='grid-item'>
              <i
                className='font-xl is24-icon-positive-check'
                style={{ color: checkmarkColor }}
                data-testid='bullet-point-checkmark'
              />
            </div>
            <div className='grid-item' data-testid='bullet-point1'>
              {bulletPointOne}
            </div>
          </div>
        </li>
      )}
      {typeof bulletPointTwo !== 'undefined' && (
        <li className='bullet-point'>
          <div className='grid grid-flex gutter-s palm-font-xs' data-testid='bullet-point'>
            <div className='grid-item'>
              <i className='font-xl is24-icon-positive-check' style={{ color: checkmarkColor }} />
            </div>
            <div className='grid-item' data-testid='bullet-point2'>
              {bulletPointTwo}
            </div>
          </div>
        </li>
      )}
      {typeof bulletPointThree !== 'undefined' && (
        <li className='bullet-point'>
          <div className='grid grid-flex gutter-s palm-font-xs' data-testid='bullet-point'>
            <div className='grid-item'>
              <i className='font-xl is24-icon-positive-check' style={{ color: checkmarkColor }} />
            </div>
            <div className='grid-item' data-testid='bullet-point3'>
              {bulletPointThree}
            </div>
          </div>
        </li>
      )}
    </ul>
  )
}

export default BulletPoints
